"use client";

import { redirect } from 'next/navigation'
interface TokenData {
  token:string;
  expiredOnMillis: number;
  user:any;
  roles:string[];
}

interface User{
  id:string;
  emailId:string;
}



export async function createSession(userId: string) {
  if (typeof window === "undefined") return;
  const expiresAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
  const session = JSON.stringify({ userId, expiresAt });
  localStorage.setItem('session', session);
}


export function getUser(){
  if(typeof window !== 'undefined'){
    
  const tokenDataString = localStorage.getItem('tokenData');
  if(tokenDataString){
    const tokenData =  JSON.parse(tokenDataString);
    if(tokenData.expiredOnMillis>(new Date()).getTime()){
      return Object.assign(tokenData.user, {roles:tokenData?.roles});
    }
  }
}
  return false; 
}

export function verifySession(refresh=true) {
  if(parseInt(process.env.NEXT_PUBLIC_ENTRA_LOGIN || '0')){
    return verifyEntraSession(refresh);    
  }
  return verifyDirectSession(refresh);
}

  export function verifyDirectSession(refresh: boolean){
    if(typeof window !== 'undefined'){
      console.log('verifying session');
      const cookie = localStorage.getItem('session') ||'{}';
      const session = JSON.parse(cookie)
     
      if (!session?.userId) {
          if(refresh){
            redirect('/login');
          }
          return { isAuth: false }
      }
      return { isAuth: true, userId: session.userId }
    }
    return { isAuth: false }
  }

  export function verifyEntraSession(refresh:boolean){
    if(typeof window !== 'undefined'){
    const tokenDataString = localStorage.getItem('tokenData');
    if(tokenDataString){
      const tokenData =  JSON.parse(tokenDataString);
      const currentTime = (new Date()).getTime();
      // console.log('time', tokenData.expiredOnMillis, currentTime, tokenData.expiredOnMillis > currentTime )

      if(tokenData.expiredOnMillis > currentTime){
        return { isAuth: true, userId: tokenData.id, }
      }else{
        if(refresh){
          redirect('/login');
        }
      }
    }
  }
    return { isAuth: false }
  }

  export function setActiveRole(role:string){
    if(typeof window !== 'undefined'){
      localStorage.setItem('activeRole', role);
    }
  }

  export function getActiveRole(){
    if(typeof window !== 'undefined'){
      return localStorage.getItem('activeRole');
    }
    return null;
  }

  export function destroySession() {
    if (typeof window === "undefined") return;
    console.log('destroying session');
    localStorage.removeItem('session');
    localStorage.clear();
    document.cookie = 'token=; Max-Age=0; path=/';
    
    // window.location.href = '/';
  } 